import addEvent from './util/addEvent';
import $ from 'jquery';

const selectors = {
	submitButton: '.button_type_submit'
};

const classes = {
	submitButtonLoading: 'button_type_submit_loading'
};

const send = (value, sendUrl) => $.ajax({
	url: sendUrl,
	data: value,
	processData: false,
	contentType: false,
	type: 'POST'
});

const submitInner = (sendUrl, success, el) => {
	$(el.currentTarget).addClass('disable-form');
	$(selectors.submitButton).addClass(classes.submitButtonLoading);
	const value = new FormData(el.currentTarget);
	send(value, sendUrl)
		.then(res => {
			success(res.data);
			$(el.currentTarget).removeClass('disable-form');
			$(selectors.submitButton).removeClass(classes.submitButtonLoading);
		})
		.fail(error => {
			console.log(error);
			$(selectors.submitButton).removeClass(classes.submitButtonLoading);
		});
};

const submit = (sendUrl, success) => e => {
	e.preventDefault();
	const checkForm = document.getElementById('check-form');
	if (checkForm) {
		if (checkForm.value === '') {
			submitInner(sendUrl, success, e);
		}
	} else {
		submitInner(sendUrl, success, e);
	}
};

const render = (form, success, url) => {
	addEvent('submit', submit(url, success), form);
};


export default render;




// WEBPACK FOOTER //
// ./app/scripts/form.js